import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaCovid from '../../components/leis/listar/covid';


function CovidScreen () {
    return (
        <Fragment>
            <Head titulo="Legislação sobre o COVID-19 do Município de Macuco"/>
            <Header />
            <Container>
                <ListaCovid />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CovidScreen;